import React from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import { useThemeMode } from '../theme';
import { mapPoints } from './mapPoints';
import { TILE_LAYERS } from './mapIcons';
import MapLayers from './MapLayers';

export default function MapViz({ rows, fields, config }) {
  useThemeMode();
  // Points are the rows with finite coordinates; the tooltip label falls back
  // to a "name" column when config.labelField is unset (shared with the export).
  const points = mapPoints(rows, fields, config);
  if (!points) return <div className="viz-empty">No latitude/longitude fields found.</div>;
  if (points.length === 0) return <div className="viz-empty">No numeric coordinate rows.</div>;

  // MapViz owns the base layer; MapLayers renders the overlay markers on top.
  const layer = TILE_LAYERS[(config && config.baseLayer) || 'osm'] || TILE_LAYERS.osm;
  return (
    <MapContainer center={[points[0].lat, points[0].lon]} zoom={5} className="viz-map">
      <TileLayer attribution={layer.attribution} url={layer.url} />
      <MapLayers points={points} config={config} />
    </MapContainer>
  );
}
